import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getPolicyContextConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'policy/context',
    method: NetworkRequestConfiguration.Methods.GET,
    errorCodes: [204],
  });
}
